/* @flow */

import React, { useContext } from "react";
import cn from "classnames";

import Wrapper from "components/Wrapper";
import Calculator from "../CalculatorView";
import PointsCollection from "components/PointsCollection";
import ContentBox from "./ContentBox";
import LeaderboardWidget from "./LeaderboardWidget";
import { StoreInfoContext } from "entrypoint/shared";

import styles from "./styles.scss";

const HomeHero = (): React$Node => {
  const { content: { homeview } } = useContext(StoreInfoContext);

  const {
    heroPrimaryInfoFieldStatus,
    heroSecondaryInfoFieldStatus,
    motivationLeaderboardWidgetIsActive,
    motivationHeroCalculatorStatus,
    motivationHeroPointsCollectionStatus,
  } = homeview;

  const isCalculatorActive: boolean =
    motivationHeroCalculatorStatus === true;

  const isLeaderboardActive: boolean =
    motivationLeaderboardWidgetIsActive === true;

  const isPointsCollectionActive: boolean =
    motivationHeroPointsCollectionStatus === true;

  const isPrimaryContentBoxActive: boolean =
    heroPrimaryInfoFieldStatus === true;

  const isSecondaryContentBoxActive: boolean =
    heroSecondaryInfoFieldStatus === true;

  let activityBox: React$Node = null;

  if (isCalculatorActive) {
    activityBox = (
      <div className={styles.calculatorWrapper}>
        <Calculator />
      </div>
    );
  }
  else if (isPointsCollectionActive) {
    activityBox = (
      <PointsCollection
        type="caramel"
        className={styles.pointsBox}
        dummyClassName={styles.pointsBox}
      />
    );
  }

  let leftBox: React$Node = activityBox;
  let rightBox: React$Node = null;

  if (isLeaderboardActive) {
    if (activityBox !== null) {
      rightBox = <LeaderboardWidget className={styles.leaderboardBox} />;
    }
    else {
      leftBox = <LeaderboardWidget className={styles.leaderboardBox} />;
    }
  }

  if (rightBox === null && (isPrimaryContentBoxActive || isSecondaryContentBoxActive)) {
    const contentBoxes = (
      <>
        {isPrimaryContentBoxActive && <ContentBox />}
        {isSecondaryContentBoxActive && <ContentBox secondary />}
      </>
    );

    rightBox = leftBox === null ? contentBoxes : (
      <div className={styles.contentBoxes}>
        {contentBoxes}
      </div>
    );
  }

  return (
    <div className={cn(styles.homeHero, "awardit-homeHero")}>
      <picture className={styles.image}>
        <source
          srcSet={homeview.heroImageSmall ?? ""}
          media={`(max-width: ${parseInt(styles.tiny, 10) - 1}px)`}
        />
        <source
          srcSet={homeview.heroImageLarge ?? ""}
          media={`(min-width: ${parseInt(styles.tiny, 10)}px)`}
        />
        <img alt="" src={homeview.heroImageLarge ?? ""} />
      </picture>
      {(leftBox !== null || rightBox !== null) &&
        <Wrapper className={styles.content}>
          {leftBox}
          {rightBox}
        </Wrapper>
      }
    </div>
  );
};

export default HomeHero;
